import { render } from "./MovimientosView.vue?vue&type=template&id=cad18606"
import script from "./MovimientosView.vue?vue&type=script&lang=js"
export * from "./MovimientosView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__